//add get inline style lib
require('./nginlinestyle');
//add the jquery visible lib
require('./ngjqvisible');


(function () {
    'use strict';

    angular
        .module('ngCanvas.dir', [
            'drag-canvas.dir',
            'website-engagement.dir',
            'add-to-list-entry.dir',
            'add-to-segment-entry.dir',
            'date-and-time.dir',
            'element-menu.dir',
            'journey.canvas.srv',
            'helpers.srv',
            'add-wait-time-action.dir',
            'update-field-action.dir',
            'send-email-action.dir',
            'add-to-list-action.dir',
            'remove-from-list-action.dir',
            'is-in-list-or-segment.dir',
            'is-in-segment.dir',
            'is-not-in-segment.dir',
            'website-activity-condition.dir',
            'email-engagement-condition.dir',
            'element-menu-if-else.dir',
            'if-else.dir',
            'editor-menu.dir',
            'facebook-audience-action.dir',
            'looping-action.dir',
            'active-add-wait-time-action.dir',
            'active-website-engagement.dir',
            'active-add-to-list-action.dir',
            'active-send-email-action.dir',
            'active-remove-from-list-action.dir',
            'active-add-to-list-entry.dir',
            'active-add-to-segment-entry.dir',
            'active-date-and-time.dir',
            'active-is-in-list-or-segment.dir',
            'active-is-in-segment.dir',
            'active-is-not-in-segment.dir',
            'active-website-activity-condition.dir',
            'active-email-engagement-condition.dir',
            'active-rectangle-connector.dir',
            'active-if-else.dir',
            'active-facebook-audience.dir',
            'active-update-field-action.dir',
            'active-looping-action.dir',
            'scroll-into.dir',
            require('./canvas_directives/triggerPanel/add-to-list-form').name,
            require('./canvas_directives/triggerPanel/add-to-segment-form').name,
            require('./canvas_directives/triggerPanel/email-engament-form').name,
            require('./canvas_directives/triggerPanel/date-time-form').name,
            require('./canvas_directives/triggerPanel/panel-alert').name,
        ])
        .run(['canvasService', '$rootScope', '$location', preloadTemplates])
        .directive('ngInitJourney', ['plumbService', '$rootScope', 'helpers', 'canvasService', 'CANVAS_OPTS', '$compile', '$timeout', ngInitJourney]);

    function ngInitJourney(plumbService, $rootScope) {
        return {
            scope: false,
            controller: ['$scope', '$http', function($scope, $http){
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.newJourneyOpts = false;
                $scope.showInitJourney = false;

               //Function to Display Menu options on the Entry Section
                function onDataCompleteListEntry(response) {
                    $scope.menuEntry = response.data;
                };

                function onError(reason) {
                    $scope.error = 'Could not load the list';
                };

                $http.get("app/services/mocks/entry.json")
                    .then(onDataCompleteListEntry, onError);

                $scope.hideJourney = function() {
                    $scope.showInitJourney = false;
                    $scope.showInitStep = false;
                    $rootScope.triggeredEntry = true;
                    let arrowConn = angular.element(document.querySelector('#newAp'));
                    jsPlumb.detachAllConnections(arrowConn);
                };

                $rootScope.$on('displayJourney', function(evt, status){
                    if($rootScope.conn && $rootScope.conn.length > 0) {
                        $scope.showInitJourney = status;
                        $scope.showInitStep = false;
                    } else {
                        $scope.showInitJourney = status;
                        $scope.showInitStep = status;
                        setTimeout(() => {
                            if (!$rootScope.conn || $rootScope.conn.length === 0) {
                                plumbService.simpleConnect('newAp', 'initial-placeholder', 'rgba(207, 207, 218, 0.3)');
                            }
                        }, 0);
                    }
                });

                $rootScope.$watch('conn', function(){
                    if($rootScope.currentJourneyStatus != 3 && $rootScope.currentJourneyStatus != 8 && $rootScope.currentJourneyStatus != 4) {
                        if($rootScope.conn && ($rootScope.conn.length == 0 || $rootScope.conn[0].type !== 'Entry')) {
                            $rootScope.$emit('displayJourney', true);
                        }

                        if ($rootScope.conn && $rootScope.conn.length > 0) {
                            $scope.showInitStep = false;
                            $scope.showInitJourney = false;

                            var entry = $rootScope.conn.find(function (element) {
                                return element.type === 'Entry';
                            });

                            if (!entry) {
                                $scope.showInitJourney = true;
                                $scope.showInitStep = false;
                            }
                        }
                    }
                });

                $scope.initJourneyCont = 0;
                $scope.$on('closeConfigMenus', function() {
                    if($scope.newJourneyOpts) {
                        if ($scope.initJourneyCont === 0) {
                            $scope.initJourneyCont = 1;
                        }else {
                            $scope.newJourneyOpts = false;
                            $scope.initJourneyCont = 0;
                        }
                    } else {
                        $scope.initJourneyCont = 0;
                    }
                });

                // Open trigger modal
                $scope.showInitialOptions = function() {
                    $rootScope.$emit('displayEntryModal');
                };
            }],
            templateUrl: 'app/views/templates/init-journey.tpl.html',
            link: function (scope, elem, attr) {
                //Inits Plumb
                plumbService.initPlumb();
            }
        }
    }

    function preloadTemplates(canvasService, $rootScope, $location) {
        //Checking url to display Journey name Element.
        $rootScope.$on('$locationChangeStart', function () {
            //Checks if path contains canvas word in the url
            var isCanvasPath = function () {
                    return $location.path().indexOf('canvas') > -1;
                },
                templateList,
                i;

            if(isCanvasPath()) {
                //Template names and sub dirs
                templateList = canvasService.getTemplateList();

                //Iterate and preload all templates
                for(i=0; i<templateList.length; i++){
                    //Preload templates
                    canvasService.preloadTemplate(templateList[i]);
                }
            }
        });
    };

}());



// WEBPACK FOOTER //
// ./app/directives/ngCanvas.directive.js